import React, { useState, useEffect, useContext } from "react";

import { AppContext } from "../../../AppContext";
import Pagination from "./Pagination";
import {
  FiPlus,
  FiEdit2,
  FiTrash2,
  FiColumns,
  FiSave,
  FiX,
  FiLayers,
  FiInbox,
} from "react-icons/fi";
import {
  tokens,
  PageShell,
  PageWidth,
  PageHeader,
  Toolbar,
  Spacer,
  Button,
  SearchInput,
  Input,
  Label,
  Field,
  Checkbox,
  TableCard,
  TableScroll,
  Table,
  Th,
  Td,
  Tr,
  Tag,
  Badge,
  EmptyState,
} from "../../admin/AdminUI";
import {
  StyledSelect,
  ModalTitle,
  ModalContent,
  ModalOverlay,
  ColumnEditRow,
  ColumnEditInner,
} from "./styled";

const ColumnModal = ({ selectedBoard, handleCloseModal }) => {
  const [updatedNewColumns, setUpdatedNewColumns] = useState([]);
  const [boardColumns, setBoardColumns] = useState([]);

  useEffect(() => {
    const initialBoardColumns = selectedBoard?.board_columns
      ? selectedBoard.board_columns.split(",").map((columnId) => ({ columnId }))
      : [];
    setBoardColumns(initialBoardColumns);
  }, [selectedBoard]);

  const addColumn = () => {
    setUpdatedNewColumns([
      ...updatedNewColumns,
      {
        columnId: "",
        columnName: "",
        columnType: "text",
        columnSize: "",
        controlType: "",
      },
    ]);
  };

  const handleColumnChange = (e, index, field) => {
    const { value } = e.target;
    const updatedColumns = [...updatedNewColumns];
    updatedColumns[index] = { ...updatedColumns[index], [field]: value };

    setUpdatedNewColumns(updatedColumns);
  };

  const handleSaveColumns = async () => {
    // 기존 컬럼은 변경 없이 신규 컬럼만 처리
    const columns = [...updatedNewColumns];
    const columnIds = columns.map(
      (column) => column.columnId || column.columnName
    ); // 각 컬럼의 ID를 추출

    try {
      const response = await fetch("/request/saveColumns", {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          boardId: selectedBoard.board_id,
          columns: columns,
          columnIds: columnIds,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to save columns");
      }

      const result = await response.json();
      handleCloseModal(); // 성공적으로 저장한 후 모달 닫기
    } catch (error) {
      console.error("Error saving columns:", error);
    }
  };

  const handleRemoveColumn = async (index, isExisting) => {
    const columnToRemove = isExisting
      ? boardColumns[index]
      : updatedNewColumns[index];

    if (isExisting) {
      const updatedBoardColumns = [...boardColumns];
      updatedBoardColumns.splice(index, 1);
      setBoardColumns(updatedBoardColumns);

      // 백엔드로 삭제 요청
      try {
        const response = await fetch("/request/deleteColumn", {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            boardId: selectedBoard.board_id,
            columnId: columnToRemove.columnId,
          }),
        });

        if (!response.ok) {
          throw new Error("Failed to delete column");
        }

        const result = await response.json();
        alert("Column deleted successfully:", result);
      } catch (error) {
        console.error("Error deleting column:", error);
      }
    } else {
      const newCols = [...updatedNewColumns];
      newCols.splice(index, 1);
      setUpdatedNewColumns(newCols);
    }
  };
  return (
    <ModalOverlay onClick={handleCloseModal}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <ModalTitle>
          <FiColumns /> 컬럼 편집
        </ModalTitle>
        <form>
          <div>
            {boardColumns.length > 0 && (
              <Label style={{ marginBottom: 10 }}>기존 컬럼</Label>
            )}
            {boardColumns.map((column, index) => (
              <ColumnEditRow key={`existing_${index}`}>
                <Tag style={{ flex: "0 0 auto" }}>컬럼 ID</Tag>
                <Input
                  style={{ flex: 1 }}
                  type="text"
                  value={column.columnId}
                  readOnly
                />
                <Button
                  $variant="dangerSoft"
                  $size="sm"
                  type="button"
                  onClick={() => handleRemoveColumn(index, true)}
                >
                  <FiTrash2 /> 삭제
                </Button>
              </ColumnEditRow>
            ))}

            <Label style={{ margin: "20px 0 12px" }}>신규 컬럼</Label>
            {updatedNewColumns.map((column, index) => (
              <ColumnEditInner key={`new_${index}`}>
                <Field $mb="12px">
                  <Label>컬럼 ID</Label>
                  <Input
                    type="text"
                    placeholder="컬럼 ID"
                    value={column.columnId || ""}
                    onChange={(e) => handleColumnChange(e, index, "columnId")}
                  />
                </Field>
                <Field $mb="12px">
                  <Label>컬럼 이름</Label>
                  <Input
                    type="text"
                    placeholder="컬럼 이름"
                    value={column.columnName || ""}
                    onChange={(e) => handleColumnChange(e, index, "columnName")}
                  />
                </Field>
                <Field $mb="12px">
                  <Label>컬럼 타입</Label>
                  <StyledSelect
                    value={column.columnType || ""}
                    onChange={(e) => handleColumnChange(e, index, "columnType")}
                  >
                    <option value="text">텍스트</option>
                    <option value="number">숫자</option>
                    <option value="date">날짜</option>
                    <option value="boolean">불리언</option>
                    <option value="file">파일</option>
                  </StyledSelect>
                </Field>
                <Field $mb="12px">
                  <Label>컬럼 크기</Label>
                  <Input
                    type="text"
                    placeholder="크기 (선택 사항)"
                    value={column.columnSize || ""}
                    onChange={(e) => handleColumnChange(e, index, "columnSize")}
                  />
                </Field>
                <Field $mb="0">
                  <Label>컨트롤 타입</Label>
                  <StyledSelect
                    value={column.controlType || ""}
                    onChange={(e) => handleColumnChange(e, index, "controlType")}
                  >
                    <option value="TextBox">텍스트박스</option>
                    <option value="NumberBox">넘버박스</option>
                    <option value="SelectBox">선택상자</option>
                    <option value="CheckBox">체크박스</option>
                    <option value="DateTimeBox">날짜선택</option>
                    <option value="Button">버튼</option>
                    <option value="ArrayInput">텍스트그룹</option>
                    <option value="FileUpload">파일업로드</option>
                  </StyledSelect>
                </Field>
              </ColumnEditInner>
            ))}
            <Button
              $variant="secondary"
              $size="sm"
              type="button"
              onClick={addColumn}
            >
              <FiPlus /> 컬럼 추가
            </Button>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 10,
              marginTop: 24,
              paddingTop: 16,
              borderTop: `1px solid ${tokens.color.borderSubtle}`,
            }}
          >
            <Button $variant="ghost" type="button" onClick={handleCloseModal}>
              <FiX /> 취소
            </Button>
            <Button $variant="primary" type="button" onClick={handleSaveColumns}>
              <FiSave /> 저장
            </Button>
          </div>
        </form>
      </ModalContent>
    </ModalOverlay>
  );
};

const EditRow = ({ board, handleSaveEdit }) => {
  const [editedBoard, setEditedBoard] = useState(board);

  const handleInputChange = (e, field) => {
    setEditedBoard({ ...editedBoard, [field]: e.target.value });
  };

  const saveEdit = () => {
    handleSaveEdit(editedBoard);
  };

  return (
    <Tr $selected>
      <Td>
        <Checkbox checked readOnly />
      </Td>
      <Td>
        <Input
          value={editedBoard.board_id}
          onChange={(e) => handleInputChange(e, "board_id")}
        />
      </Td>
      <Td>
        <Input
          value={editedBoard.board_site_id}
          onChange={(e) => handleInputChange(e, "board_site_id")}
        />
      </Td>
      <Td>
        <Input
          value={editedBoard.board_category}
          onChange={(e) => handleInputChange(e, "board_category")}
        />
      </Td>
      <Td>
        <Input
          value={editedBoard.board_title}
          onChange={(e) => handleInputChange(e, "board_title")}
        />
      </Td>
      <Td>
        <Input
          value={editedBoard.board_list_auth}
          onChange={(e) => handleInputChange(e, "board_list_auth")}
        />
      </Td>
      <Td>
        <Input
          value={editedBoard.board_read_auth}
          onChange={(e) => handleInputChange(e, "board_read_auth")}
        />
      </Td>
      <Td>
        <Input
          value={editedBoard.board_write_auth}
          onChange={(e) => handleInputChange(e, "board_write_auth")}
        />
      </Td>
      <Td>
        <Input
          value={editedBoard.board_comment}
          onChange={(e) => handleInputChange(e, "board_comment")}
        />
      </Td>
      <Td>
        <Input
          value={editedBoard.board_idx}
          onChange={(e) => handleInputChange(e, "board_idx")}
        />
      </Td>
      <Td $align="center">
        <Button $variant="primary" $size="sm" type="button" onClick={saveEdit}>
          <FiSave /> 저장
        </Button>
      </Td>
      <Td>
        <Input
          value={editedBoard.board_description}
          onChange={(e) => handleInputChange(e, "board_description")}
        />
      </Td>
    </Tr>
  );
};

const AntsBoardListAdmin = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [boards, setBoards] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedBoard, setSelectedBoard] = useState(null);
  const [newColumns, setNewColumns] = useState([]);
  const [isAddingBoard, setIsAddingBoard] = useState(false);
  const [editingRows, setEditingRows] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const { isLoggedIn, user } = useContext(AppContext);
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(10);
  const [totalPosts, setTotalPosts] = useState(0);
  const totalPages = Math.ceil(totalPosts / postsPerPage);

  const handleSearch = () => {
    getAllBoardData(currentPage, searchTerm); // 검색어와 함께 첫 페이지 데이터 가져오기
    // setCurrentPage(1); // 검색 결과를 첫 페이지부터 보여줌
  };

  const getAllBoardData = async (page, search) => {
    try {
      //console.log("검색어:"+search);
      const response = await fetch(
        `/request/get_all_boards?page=${page}&limit=${postsPerPage}&search=${encodeURIComponent(
          search
        )}`,
        {
          credentials: "include",
          headers: {
            Accept: "application/json",
          },
          method: "GET",
        }
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();
      setBoards(data.boardData);
      setTotalPosts(data.total);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const changeSearchTerm = (e) => {
    setSearchTerm(e);
    setCurrentPage(1);
  };

  useEffect(() => {
    getAllBoardData(currentPage, searchTerm);
  }, [currentPage]);

  useEffect(() => {
    if (isLoggedIn && user) {
      getAllBoardData(currentPage, searchTerm);
    }
  }, [isLoggedIn, user]);

  const handleOpenModal = (board) => {
    setSelectedBoard(board);
    setNewColumns([]);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedBoard(null);
    setNewColumns([]);
    getAllBoardData(currentPage); // 모달을 닫을 때 데이터를 다시 조회
  };

  const handleEditRows = () => {
    setEditingRows(selectedRows);
  };

  const handleSaveEdit = async (updatedBoard) => {
    const response = await fetch("/request/update_board", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(updatedBoard),
    });
    if (response.ok) {
      alert("Board updated successfully!");
      setEditingRows(editingRows.filter((id) => id !== updatedBoard.board_id));
      getAllBoardData(currentPage);
    } else {
      console.log("Failed to update board.");
    }
  };

  const handleSelectRow = (boardId) => {
    setSelectedRows((prevSelectedRows) => {
      if (prevSelectedRows.includes(boardId)) {
        return prevSelectedRows.filter((id) => id !== boardId);
      } else {
        return [...prevSelectedRows, boardId];
      }
    });
  };

  const handleDeleteBoards = async () => {
    const response = await fetch("/request/delete_boards", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ boardIds: selectedRows }),
    });
    if (response.ok) {
      console.log("Boards deleted successfully!");
      setSelectedRows([]);
      getAllBoardData(currentPage);
    } else {
      console.log("Failed to delete boards.");
    }
  };

  const allSelected =
    Array.isArray(boards) &&
    boards.length > 0 &&
    boards.every((b) => selectedRows.includes(b.board_id));

  const toggleSelectAll = () => {
    if (allSelected) {
      setSelectedRows([]);
    } else {
      setSelectedRows(boards.map((b) => b.board_id));
    }
  };

  const BoardsTable = ({ boards, handleOpenModal }) => (
    <Table>
      <thead>
        <tr>
          <Th style={{ width: 44 }}>
            <Checkbox checked={allSelected} onChange={toggleSelectAll} />
          </Th>
          <Th>게시판 ID</Th>
          <Th>사이트명</Th>
          <Th>카테고리</Th>
          <Th>게시판 TITLE</Th>
          <Th>리스트 권한</Th>
          <Th>읽기 권한</Th>
          <Th>쓰기 권한</Th>
          <Th>옵션 기능</Th>
          <Th $align="center">순서</Th>
          <Th $align="center">컬럼 편집</Th>
          <Th>설명</Th>
        </tr>
      </thead>
      <tbody>
        {Array.isArray(boards) && boards.length === 0 ? (
          <tr>
            <td colSpan="12">
              <EmptyState
                icon={<FiInbox />}
                title="게시판이 없습니다"
                description="조건에 맞는 게시판이 없습니다. 검색어를 변경하거나 새 게시판을 추가해 보세요."
              />
            </td>
          </tr>
        ) : (
          boards.map((board, index) =>
            editingRows.includes(board.board_id) ? (
              <EditRow
                key={index}
                board={board}
                handleSaveEdit={handleSaveEdit}
              />
            ) : (
              <Tr key={index} $selected={selectedRows.includes(board.board_id)}>
                <Td>
                  <Checkbox
                    checked={selectedRows.includes(board.board_id)}
                    onChange={() => handleSelectRow(board.board_id)}
                  />
                </Td>
                <Td>
                  <Tag>{board.board_id}</Tag>
                </Td>
                <Td $muted>{board.board_site_id}</Td>
                <Td>
                  {board.board_category ? (
                    <Badge $tone="brand">{board.board_category}</Badge>
                  ) : (
                    <span style={{ color: tokens.color.subtle }}>-</span>
                  )}
                </Td>
                <Td
                  style={{
                    fontWeight: 600,
                    color: tokens.color.heading,
                  }}
                >
                  {board.board_title}
                </Td>
                <Td $muted>{board.board_list_auth}</Td>
                <Td $muted>{board.board_read_auth}</Td>
                <Td $muted>{board.board_write_auth}</Td>
                <Td $muted>{board.board_comment}</Td>
                <Td $align="center" $muted>
                  {board.board_idx}
                </Td>
                <Td $align="center">
                  <Button
                    $variant="secondary"
                    $size="sm"
                    type="button"
                    onClick={() => handleOpenModal(board)}
                  >
                    <FiColumns /> 컬럼 편집
                  </Button>
                </Td>
                <Td $muted>{board.board_description}</Td>
              </Tr>
            )
          )
        )}
      </tbody>
    </Table>
  );

  const AddBoardRow = ({ onSaveNewBoard }) => {
    const [newBoard, setNewBoard] = useState({
      board_site_id: "",
      board_category: "",
      board_id: "",
      board_title: "",
      board_list_auth: "",
      board_read_auth: "",
      board_write_auth: "",
      board_comment: "",
      board_description: "",
      columns: [],
    });

    const handleNewBoardChange = (e) => {
      const { name, value } = e.target;
      setNewBoard((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    };

    return (
      <TableCard style={{ marginTop: 16 }}>
        <TableScroll>
          <Table>
            <thead>
              <tr>
                <Th>게시판 ID</Th>
                <Th>사이트명</Th>
                <Th>카테고리</Th>
                <Th>게시판 TITLE</Th>
                <Th>리스트 권한</Th>
                <Th>읽기 권한</Th>
                <Th>쓰기 권한</Th>
                <Th>댓글 기능</Th>
                <Th>순서</Th>
                <Th>설명</Th>
                <Th $align="center">저장</Th>
              </tr>
            </thead>
            <tbody>
              <Tr $hover={false}>
                <Td>
                  <Input
                    type="text"
                    placeholder="게시판 ID"
                    name="board_id"
                    value={newBoard.board_id}
                    onChange={handleNewBoardChange}
                  />
                </Td>
                <Td>
                  <Input
                    type="text"
                    placeholder="사이트명"
                    name="board_site_id"
                    value={newBoard.board_site_id}
                    onChange={handleNewBoardChange}
                  />
                </Td>
                <Td>
                  <Input
                    type="text"
                    placeholder="카테고리"
                    name="board_category"
                    value={newBoard.board_category}
                    onChange={handleNewBoardChange}
                  />
                </Td>
                <Td>
                  <Input
                    type="text"
                    placeholder="게시판 TITLE"
                    name="board_title"
                    value={newBoard.board_title}
                    onChange={handleNewBoardChange}
                  />
                </Td>
                <Td>
                  <Input
                    type="text"
                    placeholder="리스트 권한"
                    name="board_list_auth"
                    value={newBoard.board_list_auth}
                    onChange={handleNewBoardChange}
                  />
                </Td>
                <Td>
                  <Input
                    type="text"
                    placeholder="읽기 권한"
                    name="board_read_auth"
                    value={newBoard.board_read_auth}
                    onChange={handleNewBoardChange}
                  />
                </Td>
                <Td>
                  <Input
                    type="text"
                    placeholder="쓰기 권한"
                    name="board_write_auth"
                    value={newBoard.board_write_auth}
                    onChange={handleNewBoardChange}
                  />
                </Td>
                <Td>
                  <Input
                    type="text"
                    placeholder="옵션 기능"
                    name="board_comment"
                    value={newBoard.board_comment}
                    onChange={handleNewBoardChange}
                  />
                </Td>
                <Td>
                  <Input
                    type="text"
                    placeholder="순서"
                    name="board_idx"
                    value={newBoard.board_idx}
                    onChange={handleNewBoardChange}
                  />
                </Td>
                <Td>
                  <Input
                    type="text"
                    placeholder="설명"
                    name="board_description"
                    value={newBoard.board_description}
                    onChange={handleNewBoardChange}
                  />
                </Td>
                <Td $align="center">
                  <Button
                    $variant="primary"
                    $size="sm"
                    type="button"
                    onClick={() => onSaveNewBoard(newBoard)}
                  >
                    <FiSave /> 저장
                  </Button>
                </Td>
              </Tr>
            </tbody>
          </Table>
        </TableScroll>
      </TableCard>
    );
  };

  return (
    <PageShell>
      <PageWidth>
        <PageHeader
          eyebrow={
            <>
              <FiLayers /> 게시판
            </>
          }
          title="메뉴관리"
          subtitle="사이트 게시판/메뉴를 추가, 수정, 삭제하고 컬럼을 관리합니다."
          actions={
            <Button
              $variant="primary"
              onClick={() => setIsAddingBoard(true)}
            >
              <FiPlus /> 추가
            </Button>
          }
        />

        <Toolbar>
          <SearchInput
            value={searchTerm}
            onChange={(e) => changeSearchTerm(e.target.value)}
            onSearch={handleSearch}
            placeholder="게시판 ID, 제목, 카테고리 검색"
            grow="1 1 280px"
          />
          <Spacer />
          <Button
            $variant="secondary"
            onClick={handleEditRows}
            disabled={selectedRows.length === 0}
          >
            <FiEdit2 /> 수정
          </Button>
          <Button
            $variant="dangerSoft"
            onClick={handleDeleteBoards}
            disabled={selectedRows.length === 0}
          >
            <FiTrash2 /> 삭제
            {selectedRows.length > 0 ? ` (${selectedRows.length})` : ""}
          </Button>
        </Toolbar>

        <TableCard>
          <TableScroll>
            <BoardsTable boards={boards} handleOpenModal={handleOpenModal} />
          </TableScroll>
          <section
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 10,
              flexWrap: "wrap",
              padding: "14px 16px",
              borderTop: `1px solid ${tokens.color.borderSubtle}`,
            }}
          >
            <span
              style={{
                color: tokens.color.muted,
                fontSize: 13,
              }}
            >
              총 {totalPosts}건 · {currentPage} / {Math.max(totalPages, 1)}{" "}
              페이지
            </span>
            <Pagination
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              totalPages={totalPages}
            />
          </section>
        </TableCard>

        {isAddingBoard && (
          <AddBoardRow
            onSaveNewBoard={async (newBoard) => {
              const response = await fetch("/request/create_board", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                credentials: "include",
                body: JSON.stringify(newBoard),
              });
              if (response.ok) {
                //console.log('New board created successfully!');
                setIsAddingBoard(false);
                getAllBoardData(currentPage);
              } else {
                //console.log('Failed to create new board.');
              }
            }}
          />
        )}

        {isModalOpen && (
          <ColumnModal
            selectedBoard={selectedBoard}
            handleCloseModal={handleCloseModal}
          />
        )}
      </PageWidth>
    </PageShell>
  );
};

export { AntsBoardListAdmin };
